import React, { useState, useEffect } from "react";
import { api } from "../api";

export default function StatusModal({ campaignId, onClose }) {
  const [data, setData] = useState(null);

  const poll = async () => {
    try {
      const res = await api.getCampaignStatus(campaignId);
      setData(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    poll();
    const interval = setInterval(poll, 1500);
    return () => clearInterval(interval);
  }, [campaignId]);

  if (!data) return <div className="modal-backdrop"><div className="modal-content">Loading...</div></div>;

  const { campaign, records } = data;
  const processed = (campaign.sent_count || 0) + (campaign.failed_count || 0);
  const total = campaign.total_records || 1;
  const percent = Math.min(100, Math.round((processed / total) * 100));

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: "800px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3>Campaign Progress: {campaign.campaign_name}</h3>
          <button className="btn btn-outline" onClick={onClose}>Close</button>
        </div>

        <div style={{ margin: "1.5rem 0" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.875rem" }}>
            <span>Status: <strong>{campaign.status}</strong></span>
            <span>{processed} / {total} Processed ({percent}%)</span>
          </div>
          <div className="progress-bar-bg">
            <div className="progress-bar-fill" style={{ width: `${percent}%` }}></div>
          </div>
        </div>

        <div className="table-container" style={{ maxHeight: "350px", overflowY: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Mobile</th>
                <th>Status</th>
                <th>Message ID</th>
                <th>Timestamp</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {records.map((r) => (
                <tr key={r.record_id}>
                  <td>{r.mobile}</td>
                  <td><span className={`badge badge-${r.status}`}>{r.status}</span></td>
                  <td><code style={{ fontSize: "0.75rem" }}>{r.sms_message_id || "-"}</code></td>
                  <td style={{ fontSize: "0.75rem" }}>{r.sent_timestamp ? new Date(r.sent_timestamp).toLocaleTimeString() : "-"}</td>
                  <td style={{ color: "var(--danger)", fontSize: "0.75rem" }}>{r.error_message || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}